var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.17574 5.17574C5.28826 5.06321 5.44087 5 5.6 5H12.8C12.9591 5 13.1117 5.06321 13.2243 5.17574C13.3368 5.28826 13.4 5.44087 13.4 5.6V6C13.4 6.55228 13.8477 7 14.4 7C14.9523 7 15.4 6.55228 15.4 6V5.6C15.4 4.91044 15.1261 4.24912 14.6385 3.76152C14.1509 3.27393 13.4896 3 12.8 3H5.6C4.91044 3 4.24912 3.27393 3.76152 3.76152C3.27393 4.24912 3 4.91044 3 5.6V12.8C3 13.4896 3.27393 14.1509 3.76152 14.6385C4.24912 15.1261 4.91044 15.4 5.6 15.4H6C6.55228 15.4 7 14.9523 7 14.4C7 13.8477 6.55228 13.4 6 13.4H5.6C5.44087 13.4 5.28826 13.3368 5.17574 13.2243C5.06321 13.1117 5 12.9591 5 12.8V5.6C5 5.44087 5.06321 5.28826 5.17574 5.17574ZM11 11.6C11 11.2686 11.2686 11 11.6 11H18.4C18.7314 11 19 11.2686 19 11.6V18.3999C19 18.7313 18.7314 18.9999 18.4 18.9999H11.6C11.2686 18.9999 11 18.7313 11 18.3999V11.6ZM11.6 9C10.1641 9 9 10.1641 9 11.6V18.3999C9 19.8358 10.1641 20.9999 11.6 20.9999H18.4C19.8359 20.9999 21 19.8358 21 18.3999V11.6C21 10.1641 19.8359 9 18.4 9H11.6Z",
    fill: "#202020"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.18f8f18fa2b44a2ccde67bdf10d7ccb6.svg";
export { ForwardRef as ReactComponent };